// Routing rule form. A rule sends a category (optionally at one condo) to a
// primary role, with an optional backup role, supervisor role and SLA tier.
// On a default these are the rule; on an override an empty backup, supervisor
// or tier means "inherit the default's value" and is sent as null.

export const RULE_KINDS = ['default', 'override'];

export function emptyRule() {
  return {
    category: '',
    site_id: '',
    primary_role: '',
    backup_role: '',
    supervisor_role: '',
    sla_tier: '',
  };
}

export function ruleToForm(rule) {
  return {
    category: rule.category,
    site_id: rule.site_id || '',
    primary_role: rule.primary_role,
    backup_role: rule.backup_role || '',
    supervisor_role: rule.supervisor_role || '',
    sla_tier: rule.sla_tier || '',
  };
}

// Returns { field: CODE } with the codes of CO_LIVING.ROUTING.ERRORS. The
// category and condo are fixed once a rule exists, so only a new rule needs
// them.
export function validateRule(form, { kind, isEdit }) {
  const errors = {};
  if (!isEdit && !form.category) errors.category = 'CATEGORY';
  if (!isEdit && kind === 'override' && !form.site_id) errors.site_id = 'CONDO';
  if (!form.primary_role) errors.primary_role = 'PRIMARY';
  return errors;
}

export function rulePayload(form, { kind, isEdit }) {
  const body = {
    primary_role: form.primary_role,
    backup_role: form.backup_role || null,
    supervisor_role: form.supervisor_role || null,
    sla_tier: form.sla_tier || null,
  };
  if (isEdit) return body;
  return kind === 'override'
    ? { category: form.category, site_id: form.site_id, ...body }
    : { category: form.category, ...body };
}

// A category already has a default rule, a (category, condo) pair already has
// an override: offer only the free ones when adding.
export function freeCategories(categories, defaults) {
  const taken = new Set(defaults.map(rule => rule.category));
  return categories.filter(category => !taken.has(category.key));
}

export function resolveQuery({ category, siteId, date, tier }) {
  const query = { category };
  if (siteId) query.site_id = siteId;
  if (date) query.date = date;
  if (tier) query.tier = tier;
  return query;
}
